import classNames from 'classnames';
import { IconProps } from '.';

export const RefreshIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={classNames(className)}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9 2.75C7.56608 2.75 6.16437 3.17521 4.97212 3.97185C3.77986 4.76849 2.85061 5.90078 2.30187 7.22555C1.75314 8.55031 1.60956 10.008 1.88931 11.4144C2.16905 12.8208 2.85955 14.1126 3.87348 15.1265C4.88741 16.1405 6.17923 16.831 7.5856 17.1107C8.99196 17.3904 10.4497 17.2469 11.7745 16.6981C13.0992 16.1494 14.2315 15.2201 15.0282 14.0279C15.8248 12.8356 16.25 11.4339 16.25 10'
        stroke={color ?? 'var(--color-primary)'}
        strokeWidth='1.5'
      />
      <path d='M13.5 3L9 6L9 -1.96701e-07L13.5 3Z' fill={color ?? 'var(--color-primary)'} />
    </svg>
  );
};

export const DualArrowRefreshIcon = ({ className, color = 'currentColor' }: IconProps) => {
  return (
    <svg
      className={classNames(className)}
      width='18'
      height='15'
      viewBox='0 0 18 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <linearGradient
          id='dualArrowRefreshTop'
          gradientUnits='userSpaceOnUse'
          x1='5.04'
          y1='1.65'
          x2='14.6'
          y2='7.125'
        >
          <stop stopColor={color} stopOpacity='0' />
          <stop offset='1' stopColor={color} />
        </linearGradient>
        <linearGradient
          id='dualArrowRefreshBottom'
          gradientUnits='userSpaceOnUse'
          x1='12.16'
          y1='12.6'
          x2='2.6'
          y2='7.125'
        >
          <stop stopColor={color} stopOpacity='0' />
          <stop offset='1' stopColor={color} />
        </linearGradient>
      </defs>

      <path
        d='M5.04 1.65 A6.25 6.25 0 0 1 14.6 7.125'
        stroke='url(#dualArrowRefreshTop)'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path d='M14.598 10.5L12 6H17.196L14.598 10.5Z' fill={color} />

      <path
        d='M12.16 12.6 A6.25 6.25 0 0 1 2.6 7.125'
        stroke='url(#dualArrowRefreshBottom)'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path d='M2.598 3.75L5.196 8.25H0L2.598 3.75Z' fill={color} />
    </svg>
  );
};
